class MarqueeContent extends HTMLElement {
  constructor() {
    super();
    this.pauseBtn = null;
    this.marquees = [];
    this.isPaused = false;
  }

  connectedCallback() {
    this.pauseBtn = this.querySelector('[data-marque-pause]');
    this.marquees = Array.from(this.querySelectorAll('.marquee-container'));

    if (!this.pauseBtn || this.marquees.length === 0) {
      console.warn('Missing required elements in <marquee-content>');
      return;
    }

    this.pauseBtn.addEventListener('click', () => {
      this.isPaused = !this.isPaused;

      this.marquees.forEach((container) => {
        container.style.animationPlayState = this.isPaused
          ? 'paused'
          : 'running';
      });

      this.pauseBtn.setAttribute('aria-pressed', this.isPaused);
    });
  }
}

customElements.define('marquee-content', MarqueeContent);
